import React from 'react';
import StorageAppLinkBundle from 'src/cms-components/StorageAppLinkBundle/StorageAppLinkBundle';
import StorageSocialParade from 'src/cms-components/StorageSocialParade/StorageSocialParade';
import { CMS_THEME } from 'src/common/enums';

const NerdMenuComponent: React.FC<{ component: NerdMenuElement }> = ({ component }) => {
  if (!component.component) return null;

  const innerType = component.component.type;

  if (innerType === 'storage__app_link_bundle') {
    return (
      <div key={component.drupal_id} className="pds-flex pds-flex-col pds-gap-3.5">
        <h2 className="pds-text-title-sm pds-font-extrabold pds-text-neutral-text">
          {component.title}
        </h2>

        <StorageAppLinkBundle
          badgeAlignment="start"
          node={component.component}
          cmsTheme={CMS_THEME.DARK}
          analyticsEvent={{
            eventParams: {
              component_type: 'footer',
              content_name: component.title,
            },
          }}
        />
      </div>
    );
  }

  if (innerType === 'storage__social_parade') {
    return <StorageSocialParade node={component.component} />;
  }

  return null;
};

export default NerdMenuComponent;
